import { FC } from "react";

interface InfoTextProps {
  terms: string;
}

const InfoText: FC<InfoTextProps> = ({ terms }) => {
  return (
    <div className="flex flex-col p-4 gap-6 bg-[#FAF7F6]">
      <span className="text-[#99472A] font-bold text-base ">
        {globalThis.translate.em.proposal.signature_page.purchase_terms}
      </span>
      <span
        className="text-[13px] font-normal "
        dangerouslySetInnerHTML={{ __html: terms }}
      />
    </div>
  );
};

export default InfoText;
